import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { Miscellanious } from '@ops/global-config';
import {
  LocalStorageService,
  Project,
  ProjectManagerService,
  FiscalYear,
  ProjectStatusGuardService,
  SessionManagerService,
  FiscalYearService,
} from '@ops/shared-types';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-project-card-data',
  templateUrl: './project-card-data.component.html',
  styleUrls: ['./project-card-data.component.scss'],
})
export class ProjectCardDataComponent
  implements AfterViewInit, OnInit, OnDestroy
{
  @Input() project?: Project;
  @Input() detailed = true;
  @Input() isStatusPreview?: boolean;
  @Input() isShowFiscalYear?: boolean;
  @ViewChild('service') service: ElementRef<HTMLSpanElement>;

  subStatus: Subscription;
  fySubs: Subscription;
  userRoleSub: Subscription;
  fiscalYearList: Array<FiscalYear>;
  userRole: string = 'guest';
  // projectStatus: any = null;

  ngAfterViewInit() {
    if (this.service.nativeElement.clientHeight > 38) {
      this.service.nativeElement.style.fontSize = '10px';
    }
    setTimeout(() => {
      this.fiscalYearList = this.localStorageService.getFiscalYearsForCompany();
    }, 150);
  }

  companyCurrencyCode?: string;
  projectCurrencyCode?: string;

  constructor(
    private projectService: ProjectManagerService,
    private localStorageService: LocalStorageService,
    private projectStatusGuard:   ProjectStatusGuardService, // TODO: Remove this dependency
    private sessionManager: SessionManagerService,
    private router: Router,
    private fiscalYearService: FiscalYearService
  ) {
    this.projectCurrencyCode =
      this.projectService.getCurrentProject()?.projectCurrency;
    this.companyCurrencyCode =
      this.localStorageService.getCurrentCompany()?.baseCurrencyCode;
    this.fiscalYearList = this.localStorageService.getFiscalYearsForCompany();
  }
  
  ngOnInit(): void {
    setTimeout(() => {
      this.fiscalYearList = this.localStorageService.getFiscalYearsForCompany()
      console.log('fiscalYearListCARDATA', this.fiscalYearList);
    }, 150);

    // Subscribe to user role changes
    this.userRoleSub = this.sessionManager.getUserRoleObservable().subscribe((role: string) => {
      this.userRole = role;
    });
  }

  get projectStatus() {
    return this.project?.status;
  }


  /**
   * Determine if status preview should be enabled based on project status
   * Status >= 2 (Completed/Submitted) should prevent interactions
   */
  get shouldShowStatusPreview(): boolean {
    // if (this.isStatusPreview !== undefined) {
      return !!this.isStatusPreview;
    // }
    
    // If no explicit isStatusPreview is set, determine based on project status
    // return this.projectStatusGuard.shouldApplyPrevention(this.project);
  }

  ngOnDestroy(): void {
    if (this.subStatus?.unsubscribe) {
      this.subStatus.unsubscribe();
    }
    if (this.fySubs?.unsubscribe) {
      this.fySubs.unsubscribe();
    }
    if (this.userRoleSub?.unsubscribe) {
      this.userRoleSub.unsubscribe();
    }
  }

  onProjectFiscalYearChange(e) {
    // Prevent changes if project status requires prevention
    // if (this.projectStatusGuard.shouldApplyPrevention(this.project)) {
    //   return;
    // }

    if (this.fySubs?.unsubscribe) {
      this.fySubs.unsubscribe();
    }

    this.project.fiscalYear = e;

    this.fySubs = this.projectService
      .updateProjectinfo(
        this.project.versionLink,
        { fiscalYear: e },
        { fiscalYear: e },
        this.project._id
      )
      .subscribe(() => {
        // this.projectStatus =
      });
  }

  onProjectStatusChange(e) {
    
    // Note: We don't prevent status changes - we want to allow them to trigger prevention logic
    // The prevention should apply AFTER the status change, not prevent the status change itself

    if (this.subStatus?.unsubscribe) {
      this.subStatus.unsubscribe();
    }

    // Ensure status is always a string
    const statusString = e.toString();
    this.project.status = statusString;

    // Immediately update the project status guard service with the new status
    const updatedProject = { ...this.project, status: statusString };
    // console.log('Project Card Data - Updating Guard Service:', { updatedProject });
    
    // Test the service methods directly
    const shouldPrevent = this.projectStatusGuard.shouldApplyPrevention(updatedProject);
    const shouldFullPrevent = this.projectStatusGuard.shouldApplyFullPrevention(updatedProject);
    // console.log('Project Card Data - Direct Service Test:', { shouldPrevent, shouldFullPrevent });
    
    this.projectStatusGuard.setCurrentProject(updatedProject);

    this.subStatus = this.projectService
      .updateProjectinfo(
        this.project.versionLink,
        { status: e },
        { status: e },
        this.project._id
      )
      .subscribe(() => {
      });
  }

  get companyBaseCurrency() {
    return Miscellanious.currencySymbolFromCode(
      'en-US',
      this.companyCurrencyCode
    );
  }

  get projectBaseCurrency() {
    return Miscellanious.currencySymbolFromCode(
      'en-US',
      this.projectCurrencyCode
    );
  }

  /**
   * Handle click on project name or project code to navigate to project estimate
   * This works the same as clicking the project preview button in projects component
   */
  onProjectClick(): void {
    if (this.project) {
      // Set the current project in the project manager service
      this.projectService.setCurrentProject(this.project);
      
      // Navigate to project estimate page
      this.router.navigate(['project-estimate', 'project-info']);
    }
  }
}
